import {
    PUT_CARDCONFIG_FAILED,
    PUT_CARDCONFIG_LOADING,
    PUT_CARDCONFIG_SUCCESS,
} from "../types";

const initialState = {
    loading: false,
    error: null,
    status: null,
};

export const updateCardConfigReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; status: any; error: any }
) => {

   

    switch (action.type) {
        case PUT_CARDCONFIG_LOADING:
            return {
                ...state,
                loading: true,
            };
        case PUT_CARDCONFIG_SUCCESS:
            return {
                ...state,
                loading: false,
                MerchantPayment: action.payload,
                status: action.status,
                error: null,
            };
        case PUT_CARDCONFIG_FAILED:
            return {
                ...state,
                loading: false,
                status: action.status,
                error: action.error,
            };
       
        default:
            return state;
    }
};




